import React, { ReactElement, useEffect } from 'react';
import { useNavigate, NavigateFunction } from 'react-router-dom';

import { Box, Heading, Text, Button, Flex, VStack } from '@chakra-ui/react';

import { IAuthContext } from '@modules/core/contexts/auth/interfaces';
import { QuestionsItemType } from '@modules/core/aws/dynamo-db/my-circle-onboarding/interfaces';
import { useAuth, useQuery } from '@modules/core/hooks';
import { getQuestions } from '@modules/core/aws/dynamo-db/my-circle-onboarding';

import Header from '@modules/common-ui/components/header';
import Loader from '@modules/common-ui/components/global-loader';

import { welcomeStyles } from './styles';

import { APP_ROUTES } from '@modules/core/constants';

function Welcome(): ReactElement {
  const { user }: IAuthContext = useAuth();
  const navigateTo: NavigateFunction = useNavigate();
  const { isLoading, submit, res: questionsItem } = useQuery<void, QuestionsItemType>(getQuestions);

  const buttonClickHandler = () => {
    navigateTo(APP_ROUTES.onboarding, {
      state: {
        questionsItem,
      },
    });
  };

  useEffect(() => {
    submit();
  }, []);

  return (
    <Box>
      <Header />

      {!user ? (
        <Loader />
      ) : (
        <Flex flexDirection='column' {...welcomeStyles.container}>
          <VStack {...welcomeStyles.welcomeTextBox}>
            <Text as='b'>INTRODUCTION</Text>

            <Heading>Welcome to LVED, {user.contactInfo?.['First Name']}</Heading>

            <Text {...welcomeStyles.welcomeAdditionalText}>
              We are looking forward to working with you to get everything organized.
            </Text>
          </VStack>

          <Flex flexDirection='column' {...welcomeStyles.getStartedBox}>
            <Text>To get started we need to compile some basic information</Text>

            <Button
              isLoading={isLoading}
              onClick={buttonClickHandler}
              {...welcomeStyles.getStartedButton}
            >
              Let&apos;s get started
            </Button>
          </Flex>
        </Flex>
      )}
    </Box>
  );
}

export default Welcome;
